import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo1 from '../../assets/akte.jpeg';
import { headerConfig } from '../../config/header.config';
import './Header.css';
const Header: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = (path: string) => location.pathname === path;

    const navItems = [
        { label: "L'AGENCE", path: "/agence" },
        { label: "SYNDIC", path: "/syndic" },
        { label: "GESTION LOCATIVE", path: "/rental_management" },
        { label: "TRANSACTION", path: "/transaction" },
        { label: "CONTACT", path: "/contact" }
    ];

    return (
        <header className="header">
            <button className="client-space-button" onClick={() => window.open('https://akteimmobilier.monespaceclient.immo/', '_blank')}>ESPACE CLIENT</button>
            <div className="header-top">
                <div className="logo-contact-container">
                    <div className="logo-container">
                        <img src={logo1} alt="AKTE Immobilier" className="logo-main" />
                    </div>
                    <div className="contact-info">
                        <div className="phone-numbers">
                            {headerConfig.phoneNumbers.map((number, index) => (
                                <a key={index} href={`tel:${number.replace(/\s/g, '')}`} className="phone-number">
                                    {number}
                                </a>
                            ))}
                        </div>
                        <a href={`mailto:${headerConfig.email}`} className="email">
                            {headerConfig.email}
                        </a>
                    </div>
                </div>
            </div>

            <nav className="navigation">
                <div className="header-subtitle">
                    {navItems.map((item, index) => (
                        <React.Fragment key={item.path}>
                            <button
                                className={`subtitle-item nav-button ${isActive(item.path) ? 'active' : ''}`}
                                onClick={() => navigate(item.path)}
                            >
                                {item.label}
                            </button>
                            {/* Separator is managed via CSS for responsiveness, can keep logic here or hide via CSS on mobile */}
                            {index < navItems.length - 1 && (
                                <span className="subtitle-separator">-</span>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </nav>
        </header>
    );
};
export default Header